// extracted by mini-css-extract-plugin
export default {"legal":"Terms_legal__szrD8","root":"Terms_root__Nm1gE"};